import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { Formik } from 'formik';
import { AddTreatmentProtocolValidationSchema } from '../../utils/FormValidation';
import {
  CreateTreatmentprotocol,
  GetAllTreatmentprotocol,
  GetAllTreatmentservice,
} from '../../store/Actions/PrakrutistandardAction';
import { ActionUpdateById } from '../../store/Actions/CommonAction';
import { getAdminuUerDetails } from '../../store/Actions/AuthActions';
import { Button, Divider, Input, Space, Modal, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { InputFromUser } from '../../components/Input/input';
import { GetAllProgramme } from '../../store/Actions/ServiceAction';
const medicines = [
  'AGNIVARDHAK BASTI',
  'AROGYARAKASHAK BASTI',
  'ARSHA ANUVASAN BASTI',
  'ASTHIPOSHAK BASTI',
  'BIJASHUDDHI BASTI',
  'DRUSHTI BASTI',
  'GOPAL ANUVASAN BASTI',
  'KAPHAMAK BASTI',
  'KSHARNASHAK BASTI',
  'MALAVARODH BASTI',
  'MEHAGNA BASTI',
  'MUSTADI YAPAN BASTI',
  'MUTRASHMARI BASTI',
  'PANCHATIKTA BASTI',
  'PITTANASHAK BASTI',
  'PITTASHAMAK BASTI',
  'PURNA BASTI',
  'RASAYAN BASTI',
  'SHUKRAVARDHAK BASTI',
  'SIDDHA BASTI',
  'STHAULYAHAR BASTI',
  'VAITARAN BASTI',
  'VAMA BASTI',
  'VATARAKTA BASTI',
  'VATAVRODHA BASTI',
  'VATAPURNA ANUVASAN BASTI',
  'VATASHAMAK BASTI',
  'YAPAN BASTI',
  'YUKTARTHA BASTI',
  'NETRABINDU',
  'AMLADHARMI BIDALAK',
  'KSHARDHARMI BIDALAK',
  'SAMADHARMI BIDALAK',
  'PANCHAINDRIYAVARDHA',
  'SAUMYA DHUMPAN CHURN',
  'VEKHANDA',
  'AMALDHARMI NASYA OIL',
  'JIYO FRESH VEDNARI LINIMENT',
  'JOJOBA OIL',
  'KSHARDHARMI NASYA OIL',
  'MEDHAPACHAK OI',
  'NOORVI OIL',
  'SAMDHARMI NASYA OIL',
  'SANCHARIVEDANA OIL( ST OIL)',
  'SUPACHAN OIL',
  'SUVARNAKANTI OIL (RT OIL)',
  'SUKSHMASHRAVAN OI',
  'PAWAN NETRA JYOTI OIL',
  'ERANDEL OIL',
  'ANUTEL',
  'JYOTISHMATI OIL',
  'CHINCH',
  'DALCHINI CHURNA',
  'DAVNA CHURNA',
  'DHAMASA CHURNA',
  'DHANA CHURNA',
  'DURVA CHURNA',
  'GAIRIK CHURNA',
  'GOKHARU CHURNA',
  'GUD LEP',
  'GULVEL CHURNA',
  'HALAD CHURNA',
  'HIRDA CHURNA',
  'JAIPHAL CHURNA',
  'JATAMASI CHURNA',
  'JESHTHAMADH CHURNA',
  'KANCHANAR CHURNA',
  'KUDASAL CHURNA',
  'MIRE CHURNA',
  'MV1 CHURN',
  'MV 2 CHURNA',
  'MV 3 CHURNA',
  'NAGARMOTHA CHURNA',
  'NIMGHAN CHURNA',
  'PIMPALI CHURNA',
  'SAINDHAV CHURNA',
  'SARIVA CHURNA',
  'TRIFALA CHURNA',
  'VADSAL CHURNA',
  'VALA CHURNA',
  'VAVDING CHURNA',
  'VELCHI CHURNA',
  'NIRGUDI',
  'AMALA POTALI CHURNA',
  'AMALDHARMI FACE PACK',
  'APATARPAN CHURNA',
  'AWALA CHURNA',
  'CHATURTHAK LEP',
  'DANTAMAJAN',
  'ERANDBHTUSHTA TAB',
  'GANDUSH CHURNA',
  'GULAB JA',
  'KOMBADNAKHI CHURNA',
  'KSHAR POTALI CHURNA',
  'KSHARDHARMI FACE PACK',
  'MUKHAVAS',
  'NALINI UTANE',
  'PANCHGAVYA GHRIT',
  'PRANDA CHURNA',
  'ROMASHANTAN LEP',
  'HERBAL SHIRODHARA CHURN',
  'SHOBHANJAN CHURNA',
  'SHUBHRALEP',
  'SUNTH CHURNA',
  'TANUPRABHA',
  'TANUPRABHA LEP',
  'TEJ CHURNA',
  'TR LE',
  'VAMA CREAM',
  'WRAP CHURNA',
  'ROMASHATAN LEP',
  'URAH BASTI- ST + VEDANARI',
  'URAH BASTI- RT + VEDANARI',
  'URAH BASTI- MEDHPACHAK + VEDANARI',
  'URAH BASTI- NOORVI + VEDANARI',
  'SARVANG BASTI- ST + VEDANARI',
  'SARVANG BASTI- RT + VEDANARI',
  'SARVANG BASTI- MEDHPACHAK + VEDANARI',
  'SARVANG BASTI- NOORVI + VEDANARI',
  'PIZINCHIL- ST + VEDANARI',
  'PIZINCHIL- RT + VEDANARI',
  'PIZINCHIL- MEDHPACHAK + VEDANARI',
  'MEDHPACHAK OIL',
  'PIZINCHIL- NOORVI + VEDANARI',
  'TRAYODASHGUNI TAMBUL',
  'KSHASHTISHALI',
  'VALUKAPOTTALI',
  'SAINDHAVPOTTALI',
  'UDVARTAN- TEJ CHURNA +UTANE',
  'UDVARTAN- TEJ CHURNA',
  'UDVARTAN- UTANE',
  'TALAM- NAGARMOTHA',
  'TALAM-DHATRI',
  'TALAM-JATAMANSI',
  'APATARPAN LEP',
  'PRISHTHA LEP- APATARPAN + KANIK',
  'PRISHTHA LEP- CHATURTHA + KANIK',
  'PRISHTHA LEP- TANUPRABHA',
  'PRISHTHA LEP- UMBAR SAL',
  'JANU LEP- APATARPAN +KANIK',
  'JANU LEP- CHATURTHAK + KANIK',
  'JANU LEP- TABUPRABHA',
  'JANU LEP- SHULAHAR',
  'KSHARDHARMI KARNAPURAN',
  'AMLADHARMI KARNAPURAN',
  'SAMDHARMI KARNAPURAN',
  'KSHAR TALAM',
  'AMLA TALAM',
  'KASHTARTVA CHURN',
  'VASANT HARITAKI CHURN',
  'GRISHMA HARITAKI CHURN',
  'SHISHIR HARITAKI CHURN',
  'SHARAD HARITAKI CHURN',
  'VARSHA HARITAKI CHURN',
  'PATRAPOTTALI K',
  'PATRAPOTTALI A&S',
  'SANTARPANJANYA STHANIK DHARA',
  'APTARPANJANYA STHANIK DHARA',
  'IRIAMRUT TAIL GANDUSH',
  'POST RECHAN BASTI',
  'TIKSHNA BASTI',
  'DHAWAN KADHA',
  'GANDHASANKOCHAN GHRUT',
  'KAPHSHRIT VATGHAN WRAP',
  'VATGHAN LEP',
  'DHIVARDHAK DHUMPAN',
  'SHITAL DHUMPAN',
  'UDAR ROG NASHAK DHUMPAN',
  'NIDRAJANAN DHUMPAN',
  'ARSHNASHAK DHUMPAN',
  'PACHAK DHUMPAN',
];
const AddEditTreatmentProtocol = () => {
  const dispatch = useDispatch();
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;
  const { Treatmentprotocollist } = useSelector(state => state?.PrakrutiStandard);
  const { Treatmentservicelist } = useSelector(state => state?.PrakrutiStandard);
  const programmeList = useSelector(state => state?.Service?.programmeList);

  const TreatmentList = Treatmentservicelist?.[0]?.treatment || [];
  const ServiceList = Treatmentservicelist?.[0]?.service || [];
  const SolutionList = Treatmentservicelist?.[0]?.solution || [];
  let AllTreatmentList = [...TreatmentList, ...ServiceList, ...SolutionList, ...(programmeList?.[0]?.docs?.map(({ name: { en }, _id }) => { return { name: en, id: _id } }) || [])] || [];
  const { userDetails } = useSelector(state => state?.auth);
  const userId = userDetails?.[0]?._id;
  const idValue = searchParams.get('id');
  const updateValue = searchParams.get('update');

  // State for duplicate modal
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [lastSubmittedValues, setLastSubmittedValues] = useState(null);
  const formikRef = useRef(null);

  useEffect(() => {
    if (idValue) {
      dispatch(GetAllTreatmentprotocol({ Query: '/' + idValue }));
    }
  }, [idValue]);
  useEffect(() => {
    dispatch(GetAllTreatmentservice());
    dispatch(GetAllProgramme({ Query: '?limit=1000' }));
  }, []);
  useEffect(() => {
    dispatch(getAdminuUerDetails());
  }, [userId]);

  // Sync local options with saved values from the database
  useEffect(() => {
    if (Treatmentprotocollist?.[0]?.services) {
      const services = Treatmentprotocollist[0].services;

      const savedAmla = services.flatMap(s => s.amladharmi || []);
      if (savedAmla.length > 0) {
        setItems(prev => Array.from(new Set([...prev, ...savedAmla])));
      }

      const savedSama = services.flatMap(s => s.samadharmi || []);
      if (savedSama.length > 0) {
        setItems2(prev => Array.from(new Set([...prev, ...savedSama])));
      }

      const savedKshar = services.flatMap(s => s.kshardharmi || []);
      if (savedKshar.length > 0) {
        setItems3(prev => Array.from(new Set([...prev, ...savedKshar])));
      }
    }
  }, [Treatmentprotocollist]);
  const [items, setItems] = useState(medicines);
  const [name1, setName] = useState('');
  const inputRef = useRef(null);
  const onNameChange = event => {
    setName(event.target.value);
  };
  const addItem = e => {
    e.preventDefault();
    if (name1.trim() && !items.includes(name1.trim())) {
      setItems([...items, name1.trim()]);
    }
    setName('');
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  // Handle duplicate creation
  const handleDuplicateYes = () => {
    try {
      if (formikRef.current && lastSubmittedValues) {
        // Remove query parameters from URL
        const newUrl = window.location.pathname;
        window.history.pushState({}, '', newUrl);

        // Reset form with last values but clear treatment name and ID
        formikRef.current.resetForm({
          values: {
            ...lastSubmittedValues,
            treatmentName: '',
            treatmentId: '',
          },
        });
        setShowDuplicateModal(false);
        setLastSubmittedValues(null);
        message.success('Form populated with previous values. Please enter a new treatment name.');
      } else {
        message.error('Unable to duplicate. Please try again.');
        setShowDuplicateModal(false);
      }
    } catch (error) {
      console.error('Error duplicating form:', error);
      message.error('An error occurred while duplicating the form.');
      setShowDuplicateModal(false);
      setLastSubmittedValues(null);
    }
  };

  const handleDuplicateNo = () => {
    try {
      setShowDuplicateModal(false);
      setLastSubmittedValues(null);
      message.info('Redirecting to treatment protocol list...');
      setTimeout(() => {
        window.location.href = '/treatmentprotocol-list?page=1';
      }, 500);
    } catch (error) {
      console.error('Error during redirect:', error);
      window.location.href = '/treatmentprotocol-list?page=1';
    }
  };

  const [items2, setItems2] = useState(medicines);
  const [name2, setName2] = useState('');
  const inputRef2 = useRef(null);
  const onNameChange2 = event => {
    setName2(event.target.value);
  };
  const addItem2 = e => {
    e.preventDefault();
    if (name2.trim() && !items2.includes(name2.trim())) {
      setItems2([...items2, name2.trim()]);
    }
    setName2('');
    setTimeout(() => {
      inputRef2.current?.focus();
    }, 0);
  };
  const [items3, setItems3] = useState(medicines);
  const [name3, setName3] = useState('');
  const inputRef3 = useRef(null);
  const onNameChange3 = event => {
    setName3(event.target.value);
  };
  const addItem3 = e => {
    e.preventDefault();
    if (name3.trim() && !items3.includes(name3.trim())) {
      setItems3([...items3, name3.trim()]);
    }
    setName3('');
    setTimeout(() => {
      inputRef3.current?.focus();
    }, 0);
  };
  return (
    <>
      <Header />
      <Sidebar />
      <>
        <div>
          <div className="page-wrapper">
            <div className="content">
              <div className="page-header">
                <div className="row">
                  <div className="col-sm-12">
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/treatmentprotocol-list?page=1">Treatment Protocol</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <i className="feather-chevron-right">
                          <FeatherIcon icon="chevron-right" />
                        </i>
                      </li>
                      <li className="breadcrumb-item active">Add Treatment Protocol</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="card p-3">
                    <div className="card-body">
                      <Formik
                        enableReinitialize={updateValue || false}
                        innerRef={formikRef}
                        initialValues={{
                          treatmentName: Treatmentprotocollist?.[0]?.treatmentName || '',
                          treatmentId: Treatmentprotocollist?.[0]?.treatmentId,
                          services: Treatmentprotocollist?.[0]?.services || [
                            {
                              serviceName: '',
                              serviceId: '',
                              startTime: '',
                              endTime: '',
                              totalMinutes: '',
                              amladharmi: [],
                              samadharmi: [],
                              kshardharmi: [],
                            },
                          ],
                        }}
                        validationSchema={AddTreatmentProtocolValidationSchema}
                        onSubmit={(values, { setErrors, setSubmitting }) => {
                          if (updateValue && idValue != null) {
                            dispatch(
                              ActionUpdateById(
                                { Query: `admin/treatment-protocol/${idValue}`, obj: values },
                                Res => {
                                  if (Res?.statusCode === 200) {
                                    setLastSubmittedValues(values);
                                    setShowDuplicateModal(true);
                                    // window.location.href = `/treatmentprotocol-list?page=1`
                                  } else if (Res?.statusCode === 400) {
                                    setErrors(Res?.data?.errors);
                                  }
                                  setSubmitting(false);
                                }
                              )
                            );
                          } else {
                            //CreateFaq
                            dispatch(
                              CreateTreatmentprotocol(values, Response => {
                                if (Response?.statusCode === 200) {
                                  // Store submitted values and show duplicate modal
                                  setLastSubmittedValues(values);
                                  setShowDuplicateModal(true);
                                } else if (Response?.statusCode === 400) {
                                  // Handle validation errors
                                  if (Response?.data?.errors) {
                                    setErrors(Response.data.errors);
                                  }
                                  message.error(
                                    Response?.message ||
                                    'Failed to create treatment protocol. Please check the form.'
                                  );
                                } else {
                                  // Handle other errors
                                  message.error(
                                    Response?.message ||
                                    'An unexpected error occurred. Please try again.'
                                  );
                                  console.error('Create Treatment Protocol Error:', Response);
                                }
                                setSubmitting(false);
                              })
                            );
                          }
                        }}
                      >
                        {({
                          values,
                          errors,
                          touched,
                          // handleChange,
                          handleBlur,
                          handleSubmit,
                          setFieldValue,
                          setFieldTouched,
                          isSubmitting,
                        }) => {
                          return (
                            <div>
                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="form-heading">
                                    <h4>Add Treatment Protocol Data</h4>
                                  </div>
                                </div>

                                <div className="row mt-4">
                                  <InputFromUser
                                    label=" Treatment Name"
                                    type="singleSelect"
                                    FormGroupClassName={'col-xl-6 col-md-12'}
                                    LabelClassName={'col-form-label'}
                                    name="treatmentName"
                                    onChange={selectedTreatmentName => {
                                      const selectedTreatment = AllTreatmentList.find(
                                        treatment => treatment.name === selectedTreatmentName
                                      );
                                      setFieldValue('treatmentName', selectedTreatmentName);
                                      setFieldValue('treatmentId', selectedTreatment?.id || '');
                                    }}
                                    FormControlClassName={'form-control'}
                                    onBlur={value => {
                                      handleBlur({
                                        target: {
                                          name: 'treatmentName',
                                          value,
                                        },
                                      });
                                    }}
                                    error={errors?.treatmentName}
                                    value={values?.treatmentName}
                                    options={AllTreatmentList?.map(treatment => treatment?.name)}
                                    touched={touched?.treatmentName}
                                    placeholder={'Select Your Treatment'}
                                  />
                                </div>
                                <Divider style={{ fontWeight: '600' }}>Service Details</Divider>
                                <div className="invoice-add-table form-group ">
                                  <div className="table-responsive ">
                                    <table className="table table-center add-table-items">
                                      <thead>
                                        <tr>
                                          <th>Service Name</th>
                                          <th>Start Time</th>
                                          <th>End Time</th>
                                          <th>Total Minutes</th>
                                          <th>Amladharmi</th>
                                          <th>Samadharmi</th>
                                          <th>Kshardharmi</th>
                                          <th className="text-end">Actions</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {values?.services?.map((item, index) => {
                                          return (
                                            <tr key={'services' + index + 'tr'}>
                                              <td
                                                className="col-xl-2 col-md-10"
                                                key={'td3' + index}
                                              >
                                                <div>
                                                  <InputFromUser
                                                    type="text"
                                                    label=""
                                                    Showlabel={false}
                                                    mode={''}
                                                    key={'ServiceName' + index}
                                                    name="serviceName"
                                                    onChange={v => {
                                                      const updateArry = Object.assign(
                                                        [],
                                                        values.services
                                                      );
                                                      updateArry[index] = {
                                                        ...updateArry[index],
                                                        ...{ serviceName: v?.target?.value },
                                                      };
                                                      setFieldValue('services', updateArry, true);
                                                    }}
                                                    FormControlClassName={'form-control'}
                                                    value={item?.serviceName}
                                                    error={errors?.services?.[index]?.serviceName}
                                                    touched={touched?.serviceName}
                                                    // onSearchLoading={loader}
                                                    onBlur={() => {
                                                      const updateArry = Object.assign(
                                                        [],
                                                        touched.services
                                                      );
                                                      updateArry[index] = {
                                                        ...updateArry[index],
                                                        ...{ serviceName: true },
                                                      };
                                                      setFieldTouched('services', updateArry, true);
                                                    }}
                                                    placeholder={'Enter Service Name'}
                                                  />
                                                </div>
                                              </td>
                                              <td
                                                className="col-xl-1 col-md-10"
                                                key={'td4' + index}
                                              >
                                                <div>
                                                  <InputFromUser
                                                    type="text"
                                                    label=""
                                                    Showlabel={false}
                                                    mode={''}
                                                    name="startTime"
                                                    onChange={v => {
                                                      const updateArry = Object.assign(
                                                        [],
                                                        values.services
                                                      );
                                                      updateArry[index] = {
                                                        ...updateArry[index],
                                                        ...{ startTime: v?.target?.value },
                                                      };
                                                      setFieldValue('services', updateArry, true);
                                                    }}
                                                    FormControlClassName={'form-control'}
                                                    value={item?.startTime}
                                                    error={errors?.services?.[index]?.startTime}
                                                    touched={touched?.startTime}
                                                    // onSearchLoading={loader}
                                                    onBlur={() => {
                                                      const updateArry = Object.assign(
                                                        [],
                                                        touched.services
                                                      );
                                                      updateArry[index] = {
                                                        ...updateArry[index],
                                                        ...{ startTime: true },
                                                      };
                                                      setFieldTouched('services', updateArry, true);
                                                    }}
                                                    placeholder={' Start Time (0:00Am/Pm)'}
                                                  />
                                                </div>
                                              </td>
                                              <td
                                                className="col-xl-1 col-md-10"
                                                key={'td5' + index}
                                              >
                                                <div>
                                                  <InputFromUser
                                                    type="text"
                                                    label=""
                                                    Showlabel={false}
                                                    mode={''}
                                                    name="endTime"
                                                    onChange={v => {
                                                      const updateArry = Object.assign(
                                                        [],
                                                        values.services
                                                      );
                                                      updateArry[index] = {
                                                        ...updateArry[index],
                                                        ...{ endTime: v?.target?.value },
                                                      };
                                                      setFieldValue('services', updateArry, true);
                                                    }}
                                                    FormControlClassName={'form-control'}
                                                    value={item?.endTime}
                                                    error={errors?.services?.[index]?.endTime}
                                                    touched={touched?.endTime}
                                                    // onSearchLoading={loader}
                                                    onBlur={() => {
                                                      const updateArry = Object.assign(
                                                        [],
                                                        touched.services
                                                      );
                                                      updateArry[index] = {
                                                        ...updateArry[index],
                                                        ...{ endTime: true },
                                                      };
                                                      setFieldTouched('services', updateArry, true);
                                                    }}
                                                    placeholder={'End Time (0:00Am/Pm)'}
                                                  />
                                                </div>
                                              </td>
                                              <td
                                                className="col-xl-1 col-md-10"
                                                key={'td6' + index}
                                              >
                                                <div>
                                                  <InputFromUser
                                                    type="text"
                                                    label=""
                                                    Showlabel={false}
                                                    mode={''}
                                                    name="totalMinutes"
                                                    onChange={v => {
                                                      const updateArry = Object.assign(
                                                        [],
                                                        values.services
                                                      );
                                                      updateArry[index] = {
                                                        ...updateArry[index],
                                                        ...{ totalMinutes: v?.target?.value },
                                                      };
                                                      setFieldValue('services', updateArry, true);
                                                    }}
                                                    FormControlClassName={'form-control'}
                                                    value={item?.totalMinutes}
                                                    error={errors?.services?.[index]?.totalMinutes}
                                                    touched={touched?.totalMinutes}
                                                    // onSearchLoading={loader}
                                                    onBlur={() => {
                                                      const updateArry = Object.assign(
                                                        [],
                                                        touched.services
                                                      );
                                                      updateArry[index] = {
                                                        ...updateArry[index],
                                                        ...{ totalMinutes: true },
                                                      };
                                                      setFieldTouched('services', updateArry, true);
                                                    }}
                                                    placeholder={'Total Minutes'}
                                                  />
                                                </div>
                                              </td>
                                              <td
                                                className="col-xl-2 col-md-10"
                                                key={'td7' + index}
                                              >
                                                {
                                                  <InputFromUser
                                                    type="multiple"
                                                    label=""
                                                    Showlabel={false}
                                                    mode={''}
                                                    name="amladharmi"
                                                    onChange={v => {
                                                      const updatedServices = [...values.services];
                                                      updatedServices[index] = {
                                                        ...updatedServices[index],
                                                        amladharmi: v,
                                                      };
                                                      setFieldValue('services', updatedServices);
                                                    }}
                                                    FormControlClassName={'form-control'}
                                                    value={item?.amladharmi}
                                                    dropdownRender={menu => (
                                                      <>
                                                        {menu}
                                                        <Divider
                                                          style={{
                                                            margin: '8px 0',
                                                          }}
                                                        />
                                                        <Space
                                                          style={{
                                                            padding: '0 8px 4px',
                                                          }}
                                                        >
                                                          <Input
                                                            placeholder="Please enter item"
                                                            ref={inputRef}
                                                            value={name1}
                                                            onChange={onNameChange}
                                                            onKeyDown={e => e.stopPropagation()}
                                                          />
                                                          <Button
                                                            type="text"
                                                            icon={<PlusOutlined />}
                                                            onClick={(e) => {
                                                              const newItem = name1.trim();
                                                              if (newItem) {
                                                                addItem(e);
                                                                const updatedServices = [...values.services];
                                                                const currentVal = updatedServices[index].amladharmi || [];
                                                                if (!currentVal.includes(newItem)) {
                                                                  updatedServices[index] = {
                                                                    ...updatedServices[index],
                                                                    amladharmi: [...currentVal, newItem],
                                                                  };
                                                                  setFieldValue('services', updatedServices);
                                                                }
                                                              }
                                                            }}
                                                          >
                                                            Add item
                                                          </Button>
                                                        </Space>
                                                      </>
                                                    )}
                                                    onBlur={() => {
                                                      const updateArry = Object.assign(
                                                        [],
                                                        touched.services
                                                      );
                                                      updateArry[index] = {
                                                        ...updateArry[index],
                                                        ...{ amladharmi: true },
                                                      };
                                                      setFieldTouched('services', updateArry, true);
                                                    }}
                                                    error={errors?.services?.[index]?.amladharmi}
                                                    touched={errors?.services?.[index]?.amladharmi}
                                                    options={items}
                                                    placeholder={'Select Amladharmi'}
                                                  />
                                                }
                                              </td>
                                              <td
                                                className="col-xl-2 col-md-10"
                                                key={'td8' + index}
                                              >
                                                {
                                                  <InputFromUser
                                                    type="multiple"
                                                    label=""
                                                    Showlabel={false}
                                                    mode={''}
                                                    name="samadharmi"
                                                    onChange={v => {
                                                      const updateArry = Object.assign(
                                                        [],
                                                        values.services
                                                      );
                                                      updateArry[index] = {
                                                        ...updateArry[index],
                                                        samadharmi: v,
                                                      };
                                                      setFieldValue('services', updateArry, true);
                                                    }}
                                                    FormControlClassName={'form-control'}
                                                    value={item?.samadharmi}
                                                    dropdownRender={menu => (
                                                      <>
                                                        {menu}
                                                        <Divider
                                                          style={{
                                                            margin: '8px 0',
                                                          }}
                                                        />
                                                        <Space
                                                          style={{
                                                            padding: '0 8px 4px',
                                                          }}
                                                        >
                                                          <Input
                                                            placeholder="Please enter item"
                                                            ref={inputRef2}
                                                            value={name2}
                                                            onChange={onNameChange2}
                                                            onKeyDown={e => e.stopPropagation()}
                                                          />
                                                          <Button
                                                            type="text"
                                                            icon={<PlusOutlined />}
                                                            onClick={(e) => {
                                                              const newItem = name2.trim();
                                                              if (newItem) {
                                                                addItem2(e);
                                                                const updatedServices = [...values.services];
                                                                const currentVal = updatedServices[index].samadharmi || [];
                                                                if (!currentVal.includes(newItem)) {
                                                                  updatedServices[index] = {
                                                                    ...updatedServices[index],
                                                                    samadharmi: [...currentVal, newItem],
                                                                  };
                                                                  setFieldValue('services', updatedServices);
                                                                }
                                                              }
                                                            }}
                                                          >
                                                            Add item
                                                          </Button>
                                                        </Space>
                                                      </>
                                                    )}
                                                    onBlur={() => {
                                                      const updateArry = Object.assign(
                                                        [],
                                                        touched.services
                                                      );
                                                      updateArry[index] = {
                                                        ...updateArry[index],
                                                        ...{ samadharmi: true },
                                                      };
                                                      setFieldTouched('services', updateArry, true);
                                                    }}
                                                    error={errors?.services?.[index]?.samadharmi}
                                                    touched={errors?.services?.[index]?.samadharmi}
                                                    options={items2}
                                                    placeholder={'Select Samadharmi'}
                                                  />
                                                }
                                              </td>
                                              <td
                                                className="col-xl-2 col-md-10"
                                                key={'td9' + index}
                                              >
                                                {
                                                  <InputFromUser
                                                    type="multiple"
                                                    label=""
                                                    Showlabel={false}
                                                    mode={''}
                                                    name="kshardharmi"
                                                    onChange={v => {
                                                      const updateArry = Object.assign(
                                                        [],
                                                        values.services
                                                      );
                                                      updateArry[index] = {
                                                        ...updateArry[index],
                                                        kshardharmi: v,
                                                      };
                                                      setFieldValue('services', updateArry, true);
                                                    }}
                                                    FormControlClassName={'form-control'}
                                                    value={item?.kshardharmi}
                                                    dropdownRender={menu => (
                                                      <>
                                                        {menu}
                                                        <Divider
                                                          style={{
                                                            margin: '8px 0',
                                                          }}
                                                        />
                                                        <Space
                                                          style={{
                                                            padding: '0 8px 4px',
                                                          }}
                                                        >
                                                          <Input
                                                            placeholder="Please enter item"
                                                            ref={inputRef3}
                                                            value={name3}
                                                            onChange={onNameChange3}
                                                            onKeyDown={e => e.stopPropagation()}
                                                          />
                                                          <Button
                                                            type="text"
                                                            icon={<PlusOutlined />}
                                                            onClick={(e) => {
                                                              const newItem = name3.trim();
                                                              if (newItem) {
                                                                addItem3(e);
                                                                const updatedServices = [...values.services];
                                                                const currentVal = updatedServices[index].kshardharmi || [];
                                                                if (!currentVal.includes(newItem)) {
                                                                  updatedServices[index] = {
                                                                    ...updatedServices[index],
                                                                    kshardharmi: [...currentVal, newItem],
                                                                  };
                                                                  setFieldValue('services', updatedServices);
                                                                }
                                                              }
                                                            }}
                                                          >
                                                            Add item
                                                          </Button>
                                                        </Space>
                                                      </>
                                                    )}
                                                    onBlur={() => {
                                                      const updateArry = Object.assign(
                                                        [],
                                                        touched.services
                                                      );
                                                      updateArry[index] = {
                                                        ...updateArry[index],
                                                        ...{ kshardharmi: true },
                                                      };
                                                      setFieldTouched('services', updateArry, true);
                                                    }}
                                                    error={errors?.services?.[index]?.kshardharmi}
                                                    touched={errors?.services?.[index]?.kshardharmi}
                                                    options={items3}
                                                    placeholder={'Select Kshardharmi'}
                                                  />
                                                }
                                              </td>
                                              <td
                                                className="col-2 add-remove text-end align-items-center"
                                                key={'td6price'}
                                              >
                                                <div className="d-flex ">
                                                  <div>
                                                    <Button
                                                      type=""
                                                      className="add-btn "
                                                      onClick={() => {
                                                        const newValue = {
                                                          serviceName: '',
                                                          serviceId: '',
                                                          startTime: '',
                                                          endTime: '',
                                                          totalMinutes: '',
                                                          amladharmi: '',
                                                          samadharmi: '',
                                                          kshardharmi: '',
                                                        };
                                                        setFieldValue('services', [
                                                          ...values.services,
                                                          newValue,
                                                        ]);
                                                      }}
                                                    >
                                                      <i
                                                        className="fas fa-plus-circle"
                                                        style={{ color: '#2e37a4' }}
                                                      />
                                                    </Button>
                                                  </div>
                                                  <div>
                                                    <Button
                                                      style={{ border: 'none' }}
                                                      className="remove-btn "
                                                      onClick={() => {
                                                        if (index !== 0) {
                                                          const updatedBenefits = [
                                                            ...values.services,
                                                          ];
                                                          updatedBenefits.splice(index, 1);
                                                          setFieldValue(
                                                            'services',
                                                            updatedBenefits
                                                          );
                                                        }
                                                      }}
                                                    >
                                                      <i className="fe fe-trash-2">
                                                        <FeatherIcon
                                                          icon="trash-2"
                                                          className={'mb-2'}
                                                        />
                                                      </i>
                                                    </Button>
                                                  </div>
                                                </div>
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>

                                <div className="col-12 mt-4">
                                  <div className="doctor-submit text-end">
                                    <button
                                      type="submit"
                                      onClick={() => {
                                        handleSubmit();
                                      }}
                                      className="btn btn-primary submit-form me-2"
                                      disabled={isSubmitting}
                                    >
                                      Submit
                                    </button>
                                    <button type="button" className="btn btn-primary cancel-form">
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        }}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Duplicate Modal */}
        <Modal
          title="Create Duplicate"
          open={showDuplicateModal}
          onOk={handleDuplicateYes}
          onCancel={handleDuplicateNo}
          okText="Yes"
          cancelText="No"
          zIndex={9999}
          centered
          maskClosable={false}
          keyboard={false}
        >
          <p>
            Treatment protocol saved successfully! Do you want to create a duplicate with the same
            details?
          </p>
          <p style={{ fontSize: '12px', color: '#666', marginTop: '8px' }}>
            Note: The treatment name and ID will be cleared so you can enter a new name for the
            duplicate.
          </p>
        </Modal>
      </>
    </>
  );
};

export default AddEditTreatmentProtocol;
